<div class="invoice-banner">
  <div class="icon">
    <img src="../../../../assets/icons/warning.svg" />
  </div>

  <div class="banner-message">
    <strong>Note:</strong> Please be aware that Auto Pay will be automatically disabled if a payment failure occurs. Once the issue has been resolved, be sure to reactivate Auto Pay and reset your preferences to ensure payments continue to process smoothly.
  </div>

</div>

<div class="sub-container">
  <h2 class="headline-highlight">Invoice Failure Details</h2>

  <div class="search-box-container box-border">
    <div class="search-container">
      <mat-form-field class="custom-placeholder">
        <mat-icon matPrefix>search</mat-icon>
        <input
          class="search-box"
          matInput
          placeholder="Search Table"
          [(ngModel)]="searchValue"
          (keyup.enter)="applySearch(searchValue)"
        />
      </mat-form-field>

      <div class="button-container">
        <div class="btn">
          <button
            (click)="applySearch(searchValue)"
            mat-raised-button
            class="btn-balance mdc-button mdc-button--raised mat-mdc-raised-button primary"
          >
            <span class="mdc-button__label">
              <span class="button-label">
                <span>Search</span>
                <mat-icon class="mat-icon notranslate material-icons mat-ligature-font mat-icon-no-color">chevron_right</mat-icon>
              </span>
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows class="invoice-table">

      <!-- Number -->
      <ng-container matColumnDef="number">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="dw-header-cell custom-sort-header">Number</th>
        <!-- <td mat-cell *matCellDef="let row"><span class="invoice-no">{{ row.number }}</span></td> -->
         <td mat-cell *matCellDef="let row">
  <span class="invoice-no"><a [routerLink]="['/my-wallet/all-rewards/redeem/outstanding-invoice']" >
    {{ row.number }}
  </a></span>
</td>

      </ng-container>

      <!-- Billing Date -->
      <ng-container matColumnDef="billingDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="dw-header-cell custom-sort-header">Billing Date</th>
        <td mat-cell *matCellDef="let row">{{ row.billingDate | date: 'MM/dd/yyyy' }}</td>
      </ng-container>

      <!-- Due Date -->
      <ng-container matColumnDef="dueDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="dw-header-cell">Payment Failure Date</th>
        <td mat-cell *matCellDef="let row">{{ row.dueDate | date: 'MM/dd/yyyy' }}</td>
      </ng-container>

      <!-- Invoice Amount -->
      <ng-container matColumnDef="invoiceAmount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="dw-header-cell custom-sort-header">Invoice Amount</th>
        <td mat-cell *matCellDef="let row">{{ row.invoiceAmount | currency }}</td>
      </ng-container>

      <!-- Status -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef class="dw-header-cell custom-sort-header">Status</th>
        <td mat-cell *matCellDef="let row">
          <div class="status-cell" (click)="toggleExpand(row)">
            <span class="invoice-status">{{ row.status }}</span>
            <mat-icon>{{ row.isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
          </div>
        </td>
      </ng-container>

      <!-- Expanded Detail Column -->
      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length">
          <div class="expand-details">
            <div class="expand-errors">
              <span><img src="../../../../assets/icons/error_round.svg"></span> Error(s)
            </div>
            <div *ngFor="let error of row.errors; let last = last" class="expand-error-row" [ngClass]="{ 'last-error': last }">
              <div class="error-date">{{ error.billingDate | date: 'MM/dd/yyyy' }}</div>
              <div class="error-cause"><strong>Payment Failed. </strong> {{ error.cause }}</div>
            </div>
            <hr class="hr-grey"/>
            <div class="payment-method">
              <mat-icon>credit_card</mat-icon>
              Payment Methods
            </div>

          <div class="payment-sources">
            <div class="source-item">
              <img src="../../../../assets/icons/monetization_on.svg" />
              My Cash = {{ row.paymentSources?.myCash }}
            </div>

            <div class="source-item">
              <img src="../../../../assets/icons/star_rate.svg" />
              My Rewards = {{ row.paymentSources?.myRewards }} pts
            </div>

            <div *ngFor="let error of row.errors" class="source-item bank-account">
              <div class="account-wrapper">
                <img *ngIf="row.cardImage" [src]="row.cardImage" alt="Card Type" />
                <div class="text-block">
                  <div class="account-line">{{ row.paymentSources?.bankAccount }} = ${{ error.tokenAmount }}</div>
                 <div class="default" *ngIf="row.paymentSources?.isDefaultToken">
                    <span class="highlight">Default</span>
                </div>

                </div>
              </div>
            </div>
          </div>


          </div>
        </td>
      </ng-container>

      <!-- Table Headers and Rows -->
    <!-- Main Header and Row -->
<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

<!-- Expanded Detail Row: shown only if isExpanded is true -->
<tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="expanded-row" [class.hidden-row]="!row.isExpanded"></tr>
  
    </table>

    <mat-paginator
      [pageSizeOptions]="[5, 10, 20]"
      showFirstLastButtons
      class="custom-paginator"
    ></mat-paginator>
  </div>
</div>
